import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import SectionHeader from '@monorepo/shared/src/components/layout/SectionHeader';
import TabBar from 'components/common/TabBar';
import AllResources from './components/AllResources';
import AllResourcesTabHeading from './components/AllResourcesTabHeading';
import PinnedResources from './components/PinnedResources';
import PinnedResourcesTabHeading from './components/PinnedResourcesTabHeading';
import ResourcesProvider from '@monorepo/shared/src/providers/ResourcesProvider';
import useTrialUserOmitRoutes from 'state/hooks/use-trial-user-omit-routes';

const Resources: React.FC = () => {
  const location = useLocation();
  const omitRoutes = useTrialUserOmitRoutes();
  const tabList: Array<{ Component: React.FC }> = useMemo(
    () => [{ Component: AllResourcesTabHeading }, { Component: PinnedResourcesTabHeading }],
    []
  );

  const tabComponentList: Array<{ Component: React.FC }> = useMemo(
    () => [{ Component: AllResources }, { Component: PinnedResources }],
    []
  );

  return (
    <>
      <SectionHeader omitRoutes={omitRoutes} title="Resources" />
      <ResourcesProvider>
        <TabBar
          tabs={tabList}
          tabViews={tabComponentList}
          defaultTabIndex={location.pathname === '/resources' ? 0 : 1}
          handleStateChange={true}
          isElevated={false}
        />
      </ResourcesProvider>
    </>
  );
};

export default Resources;
